import React from 'react'
import { Image } from 'react-bootstrap'

function CustomImage({ src, onClick, ...props }) {
    return (
        <Image src={src} onClick={onClick} {...props} />
    )
}

export default CustomImage